"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SVGICON_LABEL_POSITION = exports.FONT_TYPE = exports.SVG_ICON_KIND = exports.ICONS_ID = exports.SEGMENT = exports.SVG_ICON_COLOR = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.log-utils");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.common");

var _gerenciatdUnifiedicons = _interopRequireWildcard(require("@bit/gerenciatd.unifiedicons.svg-icon-loader"));

require("./SvgIconLabel.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable react/no-unused-prop-types */
var SVG_ICON_COLOR = _gerenciatdUnifiedicons.COLOR;
exports.SVG_ICON_COLOR = SVG_ICON_COLOR;
var SEGMENT = _gerenciatdUnifiedicons.SEGMENT;
exports.SEGMENT = SEGMENT;
var ICONS_ID = _gerenciatdUnifiedicons.ICONS_ID;
exports.ICONS_ID = ICONS_ID;
var SVG_ICON_KIND = _gerenciatdUnifiedicons.SVG_ICON_KIND;
exports.SVG_ICON_KIND = SVG_ICON_KIND;
var FONT_TYPE = {
  REGULAR: 'font-regular',
  LIGHT: 'font-light',
  THIN: 'font-thin',
  BOLD: 'font-bold',
  HAND: 'font-hand'
};
exports.FONT_TYPE = FONT_TYPE;
var SVGICON_LABEL_POSITION = {
  TOP: 'top',
  LEFT: 'left',
  RIGHT: 'right',
  BOTTOM: 'bottom'
};
exports.SVGICON_LABEL_POSITION = SVGICON_LABEL_POSITION;

var SvgIconLabel = function SvgIconLabel(props) {
  var myProps = (0, _gerenciatdUtils2.setUpPropsByDevice)(props);
  var label = myProps.label,
      labelPosition = myProps.labelPosition,
      hideAcc = myProps.hideAcc,
      id = myProps.id,
      kind = myProps.kind,
      iconSize = myProps.iconSize,
      layoutSize = myProps.layoutSize,
      iconColor = myProps.iconColor,
      labelSize = myProps.labelSize,
      labelFont = myProps.labelFont,
      labelColor = myProps.labelColor,
      className = myProps.className,
      sizeCircular = myProps.sizeCircular,
      segment = myProps.segment,
      backgroundCircular = myProps.backgroundCircular;

  if (!id && !label) {
    (0, _gerenciatdUtils.errorLog)('[SvgIconLabel]: svgId, label are not definied', '[SvgIconLabel]:svgid|label');
    return null;
  }

  if (!id) {
    (0, _gerenciatdUtils.warnLog)('[SvgIconLabel]: svgId is not defined', '[SvgIconLabel]:svgid');
  }

  if (!label) {
    (0, _gerenciatdUtils.warnLog)('[SvgIconLabel]: label is is not defined', '[SvgIconLabel]');
  }

  var setCssLabelColor = function setCssLabelColor(mysegment, myLabelColor) {
    if (myLabelColor) {
      return " svgIL_label-".concat(mysegment, "-color--").concat(myLabelColor);
    }

    return '';
  };

  var setFontLabelCss = function setFontLabelCss(mySegment, mylabelFont) {
    if (labelFont) {
      return " svgIL_label-".concat(mySegment, "--").concat(mylabelFont);
    }

    return " svgIL_label-".concat(mySegment, "--").concat(FONT_TYPE.LIGHT);
  };

  var getLabelSize = function getLabelSize(myLabelSize) {
    if (myLabelSize) {
      return {
        fontSize: "".concat(myLabelSize, "px")
      };
    }

    return {};
  };

  var setFlexFlow = function setFlexFlow(labelPositionValue) {
    switch (labelPositionValue) {
      case SVGICON_LABEL_POSITION.RIGHT:
        return ' svgIL_row-direction';

      case SVGICON_LABEL_POSITION.LEFT:
        return ' svgIL_row-direction svgIL_row-direction--reverse';

      case SVGICON_LABEL_POSITION.TOP:
        return ' svgIL_column-direction svgIL_column-direction--reverse';

      default:
        return ' svgIL_column-direction';
    }
  };

  var flexCss = setFlexFlow(labelPosition);
  var hideAccClass = '';

  if (hideAcc) {
    hideAccClass = ' hide-acc';
  }

  var finalLabel = label ? {
    __html: label
  } : null; // trying to segment

  var mySegment = segment;

  switch (segment) {
    case 'empresas':
    case 'emp':
      mySegment = 'emp';
      break;

    case 'particulares':
    default:
      mySegment = 'gp';
      break;
  }

  var finalCssLabel = "svgIL_label".concat(setCssLabelColor(mySegment, labelColor));
  finalCssLabel = "".concat(finalCssLabel).concat(setFontLabelCss(mySegment, labelFont)).concat(hideAccClass);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    className: "svgIL".concat(flexCss).concat(className ? " ".concat(className) : ''),
    children: [id && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons["default"], {
      id: id,
      kind: kind,
      size: iconSize,
      color: iconColor,
      segment: mySegment,
      sizeCircular: sizeCircular,
      layoutSize: layoutSize,
      backgroundCircular: backgroundCircular
    }), finalLabel && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: finalCssLabel,
      style: getLabelSize(labelSize),
      dangerouslySetInnerHTML: finalLabel
    })]
  });
};

SvgIconLabel.propTypes = {
  /**
   * {
   *  "info": "Literal que aparecerá junto al icono",
   *  "kind": "both",
   *  "beautifulName": "Texto",
   *  "injectComponent": ""
   * }
   */
  label: _propTypes["default"].string,

  /**
  * {
  *  "info": "Posición del literal con respecto al objeto",
  *  "kind": "both",
  *  "beautifulName": "",
  *  "injectComponent": ""
  * }
  */
  labelPosition: _propTypes["default"].oneOf([SVGICON_LABEL_POSITION.TOP, SVGICON_LABEL_POSITION.RIGHT, SVGICON_LABEL_POSITION.BOTTOM, SVGICON_LABEL_POSITION.LEFT]),

  /**
  * {
  *  "info": "Objeto que permite esconder o mostar un elemento de la accesibilidad",
  *  "kind": "playground",
  *  "beautifulName": "",
  *  "injectComponent": ""
  * }
  */
  hideAcc: _propTypes["default"].bool,

  /**
  * {
  *  "info": "Establece el icono que se va a utilizar",
  *  "kind": "both",
  *  "beautifulName": "Icono id",
  *  "injectComponent": ""
  * }
  */
  id: _propTypes["default"].oneOf((0, _gerenciatdUnifiedicons.convertToOptions)(ICONS_ID)).isRequired,

  /**
  * {
  *  "info": "Selecciona el trazo del icono, algunos no existen para determinados iconos id",
  *  "kind": "both",
  *  "beautifulName": "Trazo",
  *  "injectComponent": ""
  * }
  */
  kind: _propTypes["default"].oneOf([SVG_ICON_KIND.LIGHT, SVG_ICON_KIND.MEDIUM, SVG_ICON_KIND.SOLID]),

  /**
  * {
  *  "info": "Selecciona el color del icono",
  *  "kind": "both",
  *  "beautifulName": "",
  *  "injectComponent": ""
  * }
  */
  iconColor: _propTypes["default"].oneOf((0, _gerenciatdUnifiedicons.convertToOptions)(_gerenciatdUnifiedicons.COLOR)),

  /**
  * {
  *  "info": "Tamaño en px del icono",
  *  "kind": "both",
  *  "beautifulName": "",
  *  "injectComponent": ""
  * }
  */
  iconSize: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
  * {
  *  "info": "Tamaño en px del texto",
  *  "kind": "both",
  *  "beautifulName": "",
  *  "injectComponent": ""
  * }
  */
  labelSize: _propTypes["default"].number,

  /**
  * {
  *  "info": "Tamaño en px del layout donde se inyectara el icono",
  *  "kind": "both",
  *  "beautifulName": "",
  *  "injectComponent": ""
  * }
  */
  layoutSize: _propTypes["default"].shape({
    w: _propTypes["default"].number,
    h: _propTypes["default"].number
  }),

  /**
  * {
  *  "info": "Selecciona el color del literal",
  *  "kind": "both",
  *  "beautifulName": "",
  *  "injectComponent": ""
  * }
  */
  labelColor: _propTypes["default"].oneOf((0, _gerenciatdUnifiedicons.convertToOptions)(_gerenciatdUnifiedicons.COLOR)),

  /**
  * {
  *  "info": "Selecciona la fuente del literal",
  *  "kind": "both",
  *  "beautifulName": "",
  *  "injectComponent": ""
  * }
  */
  labelFont: _propTypes["default"].oneOf((0, _gerenciatdUnifiedicons.convertToOptions)(FONT_TYPE)),

  /**
  * {
  *  "info": "Selecciona el segmento",
  *  "kind": "both",
  *  "beautifulName": "",
  *  "injectComponent": ""
  * }
  */
  segment: _propTypes["default"].oneOf((0, _gerenciatdUnifiedicons.convertToOptions)(SEGMENT)),

  /**
  * {
  *  "info": "Otorga un className adicional al elemento",
  *  "kind": "playground",
  *  "beautifulName": "",
  *  "injectComponent": ""
  * }
  */
  className: _propTypes["default"].string
};
SvgIconLabel.defaultProps = {
  label: '',
  labelPosition: SVGICON_LABEL_POSITION.BOTTOM,
  labelFont: FONT_TYPE.LIGHT,
  hideAcc: false,
  kind: SVG_ICON_KIND.MEDIUM,
  iconColor: _gerenciatdUnifiedicons.COLOR.INHERIT,
  labelColor: _gerenciatdUnifiedicons.COLOR.INHERIT,
  iconSize: 16,
  layoutSize: null,
  labelSize: 16,
  segment: SEGMENT.GP,
  className: ''
};
var _default = SvgIconLabel;
exports["default"] = _default;

//# sourceMappingURL=index.js.map